// extracted by mini-css-extract-plugin
export default {"container":"Can_container__R0iaT","text":"Can_text__UEQME","icon":"Can_icon__SnG7l"};